import { useState } from 'react';
import { EmptyState } from '../Kit/_index';
import { AppLightbox } from './AppLightbox';

const BLOCK = 'LStudio__app_gallery';

/*
    🔥 GALERÍA

    items: [{ id, src, thumb, alt, title, caption }]

    ⚠️ CADA MINIATURA ES UN <button>

    Un <img> con onClick no se alcanza con teclado y el lector de
    pantalla lo anuncia como imagen, no como algo que se puede abrir.

    ⚠️ loading="lazy" Y width/height EN LA MINIATURA

    Sin las medidas, el navegador no sabe cuánto espacio reservar y la
    grilla salta a medida que cargan las fotos. Acá el alto lo fija el
    CSS con aspect-ratio, que cumple la misma función.
*/

export const AppGallery = ({
    items = [],
    columns = 'auto',            // auto | 2 | 3 | 4 | 5 | 6
    ratio = '1',                 // '1' | '4/3' | '16/9'
    gap = 'md',
    hasLightbox = true,
    emptyLabel = 'No hay imágenes todavía',
    onSelect = null,
}) => {

    const [useIndex, setIndex] = useState(0);
    const [useIsOpen, setIsOpen] = useState(false);

    if (!items.length) return <EmptyState title={emptyLabel} size="sm" />;

    const onOpen = (index) => {
        onSelect?.(items[index], index);
        if (!hasLightbox) return;
        setIndex(index);
        setIsOpen(true);
    };

    return (
        <>
            <div
                className={BLOCK}
                data-columns={columns}
                data-gap={gap}
                style={{ '--LS__gallery_ratio': ratio, ...(columns === 'auto' ? {} : { '--LS__gallery_cols': columns }) }}
            >
                {
                    items.map((item, index) => (
                        <button
                            key={item.id ?? index}
                            type="button"
                            className={`${BLOCK}__cell`}
                            onClick={() => onOpen(index)}
                            aria-label={item.title ?? item.alt ?? `Imagen ${index + 1}`}
                        >

                            <img
                                className={`${BLOCK}__img`}
                                src={item.thumb ?? item.src}
                                alt={item.alt ?? ''}
                                loading="lazy"
                                draggable={false}
                            />

                            {item.title && <span className={`${BLOCK}__caption`}>{item.title}</span>}

                        </button>
                    ))
                }
            </div>

            {
                hasLightbox && (
                    <AppLightbox
                        items={items}
                        index={useIndex}
                        isOpen={useIsOpen}
                        onClose={() => setIsOpen(false)}
                        onChangeIndex={setIndex}
                    />
                )
            }
        </>
    );
};
